import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IStudentAcademicReport } from '../interfaces/academic-report';

@Injectable({
  providedIn: 'root',
})
export class AcademicReportService {
  constructor(private httpClient: HttpClient) {}

  getStudentAcademicReport(url: string, filters: any): Observable<IStudentAcademicReport> {
    return this.httpClient.get<IStudentAcademicReport>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IStudentAcademicReport>;
  }
}
